<template>
  <div class="law-page">
    <div class="top-banner">
      <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/product-bg.png" alt="Banner" class="banner-image" />

      <div class="banner-info">
        <div class="title">多语言文件转换</div>
        <div class="space"></div>
        <div class="info">专注医疗垂直领域文件翻译，深度聚焦药品监管文件、医疗器械标准、临床试验协议、GMP认证材料、患者知情书等法规类文本，为药企、械企、CRO机构、医疗机构提供「翻译+审校+排版」全链路合规服务，打破国际医疗合作的沟通壁垒。</div>
        <div class="btn">
          <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/btn.png" class="btn" alt="">
        </div>
      </div>
    </div>

    <div class="law-main">
      <div class="section-title">
        <h2>服务介绍</h2>
        <div class="title-underline"></div>
      </div>
      
      <div class="law-table">
        <Swipe :autoplay="5000" :loop="true" :touchable="true" :show-indicators="false">
          <SwipeItem>
            <div class="banner-item">
              <div class="info">
                <div class="title">权威医疗语料库支撑</div>
                <div class="item">
                  <div class="desc">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    基于超百万条医疗法规术语数据库（涵盖FDA、EMA、NMPA等全球30+监管机构标准）
                  </div>
                </div>
                <div class="item">
                  <div class="desc">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    AI预训练模型深度适配医疗文本，确保专业术语零误差，避免“误译导致的合规风险”
                  </div>
                </div>
                <div class="item">
                  <div class="desc">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    翻译团队均具备医学/药学背景+5年以上法规翻译经验，熟悉ICH、ISO13485等国际规范
                  </div>
                </div>
              </div>
              <div class="bg-box">
                <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/language-table.png" class="table-bg" alt="" @dragstart.prevent>
              </div>
            </div>
          </SwipeItem>
          <SwipeItem>
            <div class="banner-item">
              <div class="info small">
                <div class="title">28语种全覆盖，智能与人工精准协作</div>
                <div class="item">
                  <div class="desc">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    支持英语、日语、德语、西班牙语、阿拉伯语等28种语言互译（持续扩展中）
                  </div>
                </div>
                <div class="item">
                  <div class="desc">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    AI闪电初译：1小时内完成万字文档处理，较传统翻译效率提升10倍
                  </div>
                </div>
                <div class="item">
                  <div class="desc">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    专家级精校：三重审校机制（医学译员校准→法律顾问合规审查→母语专家润色）
                  </div>
                </div>
                <div class="item">
                  <div class="desc">
                    <Icon name="success" color="#68BBC4" size="20"/>
                    排版严格遵循目标国格式规范（如欧盟CE技术文件结构、日本PMDA申报模板）
                  </div>
                </div>
              </div>
              <div class="bg-box">
                <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/language-table2.png" class="table-bg" alt="" @dragstart.prevent>
              </div>
            </div>
          </SwipeItem>
        </Swipe>
      </div>


      <div class="section-title">
        <h2>全流程质控</h2>
        <div class="title-underline"></div>
      </div>

      <div class="">
        <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/process.png" class="process-img" alt="">
      </div>


      <div class="section-title">
        <h2>适用场景</h2>
        <div class="title-underline"></div>
      </div>

      <div class="good-box">
        <div class="good-item" v-for="(item, i) in goodList" :key="i">
          <div class="title">
            <span class="text">{{ item.title }}</span>
          </div>
          <div class="item">
            <div class="desc">
              {{ item.desc1 }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swipe, SwipeItem, Icon } from 'vant';
import '@vant/touch-emulator'



const goodList = [
  {
    title: '药企',
    desc1: '辅助药品海外注册（如FDA 510k文件、EMA上市许可材料本地化）',
  },
  {
    title: '器械公司',
    desc1: '确保CE认证技术文档、IFU说明书多语言合规',
  },
  {
    title: '跨境临床试验',
    desc1: '同步翻译知情同意书、CRF表至28国语言，保障伦理审查通过率',
  },
  {
    title: '医院集团',
    desc1: '海外医疗合作项目协议、国际诊疗标准手册精准转化',
  },
]

</script>

<style lang="less" scoped>
.law-page {
  position: relative;
  min-height: 100vh;
  min-width: 1400px;
  background: #fff;
  padding-bottom: 30px;
  
  .banner-info {
    position: absolute;
    right: 100px;
    top: 0;
    height: 600px;
    padding-bottom: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    
    .title {
      font-family: YouSheBiaoTiHei;
      font-size: 72px;
      line-height: 90px;
      color: #101010;
    }
    
    .space {
      width: 160px;
      height: 24px;
      margin: 32px 0 44px;
      background: linear-gradient(228.23deg, rgba(35,19,176,0.83) 12.42%,rgba(128,152,219,0.9) 47.6%,rgba(135,183,219,0.82) 73.98%,rgba(165,227,255,0.75) 97.43%);
    }
    
    .info {
      width: 810px;
      
      font-size: 20px;
      line-height: 35px;
      color: #101010;
      text-align: right;
    }
    
    .btn {
      margin-top: 40px;
      
      img {
        width: 200px;
        cursor: pointer;
        transition: all .3s;
        
        &:hover {
          transform: scale(1.02);
        }
      }
    }
  }

  .top-banner {
    width: 100%;
    height: 600px;
    overflow: hidden;
    
    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  }

  .law-main {
    padding: 60px 0;
    width: 1400px;
    margin: 0 auto;
    .section-title {
      text-align: left;
      margin-bottom: 60px;
      
      h2 {
        
        font-size: 48px;
        color: #101010;
        margin-bottom: 10px;
      }
      
      .title-underline {
        width: 440px;
        height: 7px;
        background: #1e40af;
      }
    }

    
  }


  .law-table {
    width: 1400px;
    height: 600px;
    margin: 60px auto 80px;
    border: 1px solid rgba(0, 0, 0, 0.4);
    border-radius: 24px;
    overflow: hidden;
    .banner-item {
      display: flex;
      .info {
        width: 30%;
        padding: 60px 65px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        
        color: #101010;
        font-size: 18px;
        &.small {
          padding-top: 32px;
          .title {
            margin-bottom: 24px;
          }
          .item {
            & + .item {
              margin-top: 20px;
            }
          }
        }
        .title {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 40px;
        }
        .item {
          text-align: left;
          & + .item {
            margin-top: 30px;
          }
          .desc {
            display: flex;
            font-size: 20px;
            .van-icon {
              margin-right: 10px;
              margin-top: 5px;
            }
          }
        }
      }
      .bg-box {
        position: relative;
        width: 70%;
        height: 598px;
        background: linear-gradient(-45.17deg, rgba(187,198,255,0.82) 10.21%,rgba(147,199,244,0.38) 59.01%,rgba(253,247,244,0.81) 93.87%);
        padding: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        .table-bg {
          height: 480px;
          width: 100%;
          border: 1px solid #6EB2FF;
          border-radius: 10px;
          overflow: hidden;
        }
        .item-img {
          position: absolute;
          right: 26px;
          bottom: 55px;
          width: 500px;
        }
        .item-img2 {
          position: absolute;
          left: 30px;
          bottom: 55px;
          width: 500px;
        }
        .item-img3 {
          position: absolute;
          right: 34px;
          top: 60px;
          width: 400px;
          background: #fff;
        }
      }
    }
  }

  .service-list {
    width: 1400px;
    margin: 100px auto 0;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 33.33%;
      margin-bottom: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      
      img {
        width: 200px;
        height: 240px;
        object-fit: contain;
        margin-bottom: 6px;
      }
      .item-title {
        margin-bottom: 15px;
        font-size: 24px;
        font-weight: bold;
        color: #101010;
      }
      .item-desc {
        width: 250px;
        font-size: 16px;
        color: rgba(16, 16, 16, .5);
      }
    }
  }

  .good-box {
    width: 1400px;
    margin: 0 auto;
    display: flex;
    gap: 20px;
    .good-item {
      flex: 1;
      height: 340px;
      box-shadow: 2px 2px 8px 0px rgba(222,223,224,0.7);
      border-radius: 24px;
      overflow: hidden;
      
      background: linear-gradient(179.54deg, rgba(187,216,255,0.82) 20.46%,rgba(255,255,255,0.79) 56.39%,rgba(255,255,255,1) 89.33%);
      transition: all .3s;
      &:hover {
        transform: translateY(-4px);
      }
      .title {
        width: 100%;
        height: 120px;
        background: linear-gradient(129.36deg, rgba(64,125,255,1) 27.62%,rgba(121,212,255,0.82) 79.79%,rgba(131,235,255,1) 94.44%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-weight: bolder;
        font-size: 48px;
      }
      .item {
        padding: 40px 40px;
        text-align: left;
        .desc {
          font-size: 22px;
          line-height: 28px;
        }
      }
    }
  }

  .process-img {
    width: 100%;
    margin-bottom: 40px;
  }
}



// 小分比率适配
@media screen and (max-width: 1560px) {
  .law-page {
    min-width: 1200px;
    .top-banner {
      height: 540px;
      .banner-info {
        height: 540px;
        .title {
          font-size: 66px;
          line-height: 84px;
        }
        .space {
          height: 22px;
        }
        .info {
          font-size: 18px;
        }
        .btn {
          margin-top: 34px;
        }
      }
    }

    .law-main {
      width: 1200px;
      .section-title {
        margin-bottom: 52px;
        h2 {
          font-size: 42px;
        }
        .title-underline {
          width: 380px;
          height: 6px
        }
      }

      .law-table {
        width: 1200px;
        height: 520px;
        margin-bottom: 70px;
        .banner-item {
          .info {
            padding: 40px 45px;
            font-size: 16px;
            &.small {
              padding-top: 26px;
              .title {
                margin-bottom: 20px;
              } 
              .item {
                & + .item {
                  margin-top: 16px;
                }
              }
            }
            .title {
              font-size: 24px;
              margin-bottom: 48px;
            }
            .item {
              & + .item {
                margin-top: 32px;
              }
              .desc {
                font-size: 18px;
              }
            }
          }
          .bg-box {
            height: 518px;
            .table-bg {
              height: 416px;
            }
            .item-img {
              width: 280px;
            }
          }
        }
      }

      .service-list {
        width: 1200px;
      }

      .good-box {
        width: 1200px;
        .good-item {
          height: 300px;
          .title {
            height: 100px;
            font-size: 42px;
          }
          .item {
            padding: 30px 30px;
            .desc {
              font-size: 20px;
            }
          }
        }
      }
    }
  }
}


// 小分比率适配
@media screen and (max-width: 1400px) {
  .law-page {
    min-width: 1080px;
    .top-banner {
      height: 500px;
      .banner-info {
        height: 500px;
        .title {
          font-size: 60px;
          line-height: 72px;
        }
        .space {
          height: 20px;
        }
        .info {
          font-size: 16px;
        }
        .btn {
          margin-top: 30px;
        }
      }
    }

    .law-main {

      .section-title {
        margin-bottom: 36px;
        h2 {
          font-size: 36px;
        }
        .title-underline {
          width: 350px;
          height: 5px
        }
      }
  
      .law-table {
        width: 1080px;
        height: 480px;
        margin-bottom: 60px;
        .banner-item {
          .info {
            padding: 30px 33px;
            font-size: 14px;
            .title {
              font-size: 20px;
              margin-bottom: 40px;
            }
            .item {
              & + .item {
                margin-top: 26px;
              }
              .desc {
                font-size: 16px;
              }
            }
          }
          .bg-box {
            height: 478px;
            .table-bg {
              height: 384px;
            }
            .item-img {
              width: 250px;
            }
          }
        }
      }
  
      .service-list {
        width: 1080px;
      }
  
      .good-box {
        width: 1080px;
        .good-item {
          height: 260px;
          .title {
            height: 80px;
            font-size: 36px;
          }
          .item {
            padding: 20px 20px;
            .desc {
              font-size: 18px;
            }
          }
        }
      }
    }
  }
}
</style>